import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/tipo-inconformidade';

export default {

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async getSimpleListIds(ids){
    return Http.post(`${path}/simple`, ids);
  },

}
